export function formatExtraKey(key: string): string {
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
    .trim();
}

export function isRecentlyDetected(
  dateStr: string | null | undefined
): boolean {
  if (!dateStr) return false;
  const date = new Date(dateStr);
  const dayAgo = Date.now() - 24 * 60 * 60 * 1000;
  return date.getTime() > dayAgo;
}

export const PAGE_SIZE = 20;
